import React, { useState, useEffect } from "react";

function BannerCarousel({ items, autoplayEnabled, autoplayInterval = 5000, isMobile }) {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        if (!autoplayEnabled || items.length <= 1) return;
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % items.length);
        }, autoplayInterval);
        return () => clearInterval(interval);
    }, [autoplayEnabled, autoplayInterval, items.length]);

    if (items.length === 0) return null;

    return (
        <div
            role="region"
            aria-label="Banners em destaque"
            aria-roledescription="carrossel"
            aria-live="polite"
            aria-atomic="true"
            style={{ position: "relative", overflow: "hidden", width: "100%" }}
        >
            <div
                style={{
                    display: "flex",
                    transition: "transform 0.5s ease-in-out",
                    transform: `translateX(-${currentIndex * 100}%)`,
                }}
            >
                {items.map((item, index) => (
                    <div
                        key={item._id}
                        style={{
                            minWidth: "100%",
                            maxWidth: "100vw",
                            flexShrink: 0,
                        }}
                    >
                        {item.link && item.link !== "" ? (
                            <a
                                href={item.link}
                                rel="noreferrer"
                                target="_blank"
                                aria-label={`${item.description || `Banner ${index + 1}`} `}
                            >
                                <img
                                    alt={item.description || `Banner ${index + 1} do Sindsep`}
                                    src={
                                        isMobile && item.imageMobile
                                            ? item.imageMobile
                                            : item.image
                                    }
                                    style={{
                                        width: "100%",
                                        minWidth: "100vw",
                                        maxWidth: "100vw",
                                        display: "block",
                                    }}
                                />
                            </a>
                        ) : (
                            <img
                                alt={item.description || `Banner ${index + 1} do Sindsep`}
                                src={
                                    isMobile && item.imageMobile
                                        ? item.imageMobile
                                        : item.image
                                }
                                style={{
                                    width: "100%",
                                    minWidth: "100vw",
                                    maxWidth: "100vw",
                                    display: "block",
                                }}
                            />
                        )}
                    </div>
                ))}
            </div>

            {items.length > 1 && (
                <div
                    style={{
                        position: "absolute",
                        bottom: 16,
                        left: "50%",
                        transform: "translateX(-50%)",
                        display: "flex",
                        gap: 8,
                    }}
                >
                    {items.map((_, index) => (
                        <button
                            key={index}
                            type="button"
                            onClick={() => setCurrentIndex(index)}
                            aria-label={`Ir para banner ${index + 1} de ${items.length}`}
                            aria-current={index === currentIndex ? "true" : undefined}
                            style={{
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                border: "2px solid #FFFFFF",
                                backgroundColor: index === currentIndex ? "#FFFFFF" : "transparent",
                                cursor: "pointer",
                                padding: 0,
                            }}
                        />
                    ))}
                </div>
            )}
        </div>
    );
}

export default BannerCarousel;
